<div id="head"></div>
<h1 class="sr-only">AI Price Watch - LLM Token Price Chart and Tracker for Claude, GPT and Gemini</h1>

<!-- ===================== Hero: the board ===================== -->
<div class="default-section initial-section metallic-section no-buttons wp-hero" data-section="top">
  <div class="cp-hero-head">
    <p class="tools-title" aria-hidden="true">AI Price Watch</p>
    <p class="tools-subtitle">Track every AI token price change, model by model and day by day</p>
  </div>

  <div class="ap-card aw-card">
    <app-ai-price-watch-widget [model]="model" [field]="field" [range]="range" [query]="query"
                               (boardChange)="onBoard( $event )"></app-ai-price-watch-widget>
  </div>
</div>

<nav class="cp-chipbar" appStuck aria-label="AI Price Watch sections">
  <div class="cp-chipbar-row">
    <a *ngFor="let s of pageSections" class="pl-chip" [class.on]="activeSection === s.key" [attr.href]="'#sec-' + s.key"
       (click)="$event.preventDefault(); scrollToSection( s.key )">
      <span>{{ s.label }}</span>
    </a>
  </div>
</nav>

<div class="cp-body cp-boxes">
  <div class="cp-content">

    <!-- every model with its change over each range; a row puts its model on the board -->
    <section class="cp-section" id="sec-compare" data-section="compare">
      <header class="cp-head">
        <h2 class="cp-h2">Compare Every Model</h2>
        <p class="cp-section-lead">Every model on every platform with its {{ fieldName }} price and how far it moved over one, three and six months, the year so far and a year; click a row to see it on the chart</p>
      </header>
      <div class="cp-main">
        <div class="ap-controls">
          <nav class="ap-platforms" aria-label="Platforms">
            <button type="button" class="pl-chip" [class.on]="tablePlatform === 'all'" (click)="setTablePlatform( 'all' )"><span>All Platforms</span></button>
            <button type="button" class="pl-chip" *ngFor="let key of platformKeys" [class.on]="tablePlatform === key" (click)="setTablePlatform( key )"><img class="ap-picon" [src]="platformIcon( key )" alt="" width="16" height="16"><span>{{ platformLabel( key ) }}</span></button>
          </nav>
          <label class="ap-search">
            <span class="sr-only">Search models</span>
            <input type="search" [ngModel]="tableQuery" (ngModelChange)="setTableQuery( $event )" placeholder="Search a model, a vendor or a platform" autocomplete="off" spellcheck="false">
          </label>
        </div>

        <div class="ap-table-wrap" *ngIf="compareRows.length; else compareEmpty">
          <table class="ap-table aw-compare">
            <thead>
              <tr>
                <th scope="col"><button type="button" class="ap-sort" [class.on]="sortKey === 'name'" [class.desc]="sortKey === 'name' && sortDesc" (click)="sortBy( 'name' )">Model</button></th>
                <th scope="col" class="ap-num"><button type="button" class="ap-sort" [class.on]="sortKey === 'price'" [class.desc]="sortKey === 'price' && sortDesc" (click)="sortBy( 'price' )">{{ fieldLabel }}</button></th>
                <th scope="col" class="ap-num" *ngFor="let r of ranges; let i = index"><button type="button" class="ap-sort" [class.on]="sortKey === i" [class.desc]="sortKey === i && sortDesc" (click)="sortBy( i )">{{ r.label }}</button></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of compareRows" class="ac-row" [class.on]="model === r.id" (click)="pickFromTable( r.id )">
                <td><span class="ap-name">{{ r.name }}</span><span class="ap-id ap-id-row"><span class="ap-plat"><img class="ap-picon" [src]="platformIcon( r.platform )" alt="" width="14" height="14">{{ platformLabel( r.platform ) }}</span><span class="ap-cost">· {{ price( r.input ) }} in, {{ price( r.output ) }} out</span></span></td>
                <td class="ap-num">{{ price( r.price ) }}</td>
                <td class="ap-num" *ngFor="let c of r.changes">
                  <span class="aw-pct" [class.down]="!!c && c < 0" [class.up]="!!c && c > 0">{{ c === null ? '·' : pctLabel( c ) }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ng-template #compareEmpty>
          <p class="ap-empty" *ngIf="prices">No model matches. Try another word or pick another platform</p>
          <p class="ap-empty" *ngIf="!prices">Loading the prices</p>
        </ng-template>
        <p class="ap-foot">USD per million tokens from the daily price table; click a column to sort by it, a second time to turn the order around</p>
      </div>
    </section>

    <!-- More AI Tools: AI Token Meter, the menu bar app that counts the tokens these prices apply to -->
    <app-more-tools title="More AI Tools" lead="Count the tokens your coding agents really use, then see what each price move means for them"
                    [app]="aiTokenMeter" source="ai-price-watch"></app-more-tools>

    <app-tool-about [lead]="aboutLead" [paragraphs]="aboutParagraphs" [faq]="faq" ratingKey="ai-price-watch" ratingName="AI Price Watch"></app-tool-about>
  </div>
</div>
